import { generate } from '@/utils/request';
const config = {
  prefix: '/sgoo/v1/{organizationId}',
  items: [
    // 商品条形码查询
    { key: 'getQueryBarcode', url: '/goods/barcode/page', method: 'POST' },
    // 批量删除
    { key: 'batchDeleteBarcode', url: '/goods/barcode/batch-delete-barcode', method: 'PATCH' },
    // 获取一条最早的未被占用的条形码
    { key: 'getoneBarcode', url: '/goods/barcode/getone', method: 'PATCH' },
  ],
};
export default {
  ...generate(config),
};
